export default __webpack_public_path__ + "static/media/36I-102629_-15542_0.2cb47b23.jpg";